import React from 'react';
import PropTypes from 'prop-types';

import { useIntl, defineMessages } from 'react-intl';
import { Image } from 'semantic-ui-react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import {
  flattenToAppURL,
  flattenHTMLToAppURL,
} from '@plone/volto/helpers/Url/Url';

const messages = defineMessages({
  itinerary_step: { id: 'itinerary_step', defaultMessage: 'Tappa' },
  discover: { id: 'itinerary_step_discover', defaultMessage: 'Scopri' },
});

const StepExpanded = ({ step, number }) => {
  const intl = useIntl();
  return (
    <div className="step">
      <h3>
        {number} {intl.formatMessage(messages.itinerary_step)}: {step.title}
      </h3>
      <div className="step-content">
        {step.description && (
          <div className="description">{step.description}</div>
        )}
        {step.text && (
          <div className="text">
            <div
              className="p-no-margin"
              dangerouslySetInnerHTML={{
                __html: flattenHTMLToAppURL(step.text.data),
              }}
            />
          </div>
        )}

        {/* image */}
        {step.image?.scales?.large?.download && (
          <div className="step-image">
            {step.image.scales.large.download && (
              <figure>
                <Image
                  src={flattenToAppURL(step.image.scales.large.download)}
                  alt={step.title}
                  loading="lazy"
                />
              </figure>
            )}
          </div>
        )}
        {step.point_of_interest?.length > 0 && (
          <div className="step-more">
            <UniversalLink
              className="ui button primary"
              item={step.point_of_interest[0]}
            >
              {intl.formatMessage(messages.discover)}
            </UniversalLink>
          </div>
        )}
      </div>
    </div>
  );
};

StepExpanded.propTypes = {
  path: PropTypes.string.isRequired,
  number: PropTypes.string.isRequired,
};
export default StepExpanded;
